// insert player function
$.fn.insertPlayer = function () {
    let $video = $(this),
        $placeholder = $video.find('.fancy-video__placeholder'),
        $button = $video.find('.fancy-video__play'),
        vidWidth = $video.outerWidth(),
        vidHeight = $video.outerHeight(),
        vidID = $video.data('media-id'),
        iframe;

    if ($video.attr('class').indexOf('youtube') >= 0) {
        iframe = '<iframe class="fancy-video__player" src="https://www.youtube.com/embed/' + vidID + '?autoplay=1&autohide=1&showinfo=0&controls=1&border=0&modestbranding=0&wmode=opaque&enablejsapi=1&version=3hl=nl_NL&rel=0&hd=1&iv_load_policy=3&mute=1" width="' + vidWidth + '" height="' + vidHeight + '" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
    }

    if ($video.attr('class').indexOf('vimeo') >= 0) {
        iframe = '<iframe class="fancy-video__player" src="https://player.vimeo.com/video/' + vidID + '" width="' + vidWidth + '" height="' + vidHeight + '" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
    }

    if ($video.attr('class').indexOf('file') >= 0) {
        iframe = '<video class="fancy-video__player" autoplay muted loop playsinline controls width="' + vidWidth + '" height="' + vidHeight + '"><source src="' + vidID + '"></video>';
    }

    if (iframe && typeof vidID !== "undefined" && vidID !== '') {
        if (!$video.hasClass('fancy-video--playing')) {
            $video.addClass('fancy-video--playing');
        }

        $placeholder.hide();
        $button.hide();
        $video.append(iframe);
    }
};


$('.fancy-video__placeholder').on('click', function () {
    $(this).siblings('.fancy-video__play').trigger('click');
});


$('.fancy-video__play').on('click', function () {
    let $video = $(this).closest('.fancy-video');

    if ($video.length > 0) {
        $video.insertPlayer();
    }
});

$('.btn--play-video').on('click', function () {
    let $video = $('.fancy-video[data-video-id="' + $(this).data('video-id') + '"]');

    if ($video.length > 0 && !$video.hasClass('fancy-video--playing')) {
        $video.insertPlayer();
    }
});


// icon animation on scroll
$('.video-block__icon.video-block__icon--animated').each(function () {
    let $icon = $(this),
        availableSpace = $(this).parent().width() - $(this).width(),
        inViewport = false;

    // if icon is in view, move to right on scroll
    let inview = new Waypoint.Inview({
        element: $icon[0],
        enter: function () {
            inViewport = true;
        },
        exited: function () {
            inViewport = false;
        }
    });

    window.addEventListener('scroll', function () {
        let scrolledDistance = $(document).scrollTop();

        if (inViewport) {
            // determine position (percetage) of icon relative to viewport on Y axis
            let yOffset = $icon.offset().top - scrolledDistance,
                yPercentage = (yOffset / viewport().height) * 100;

            if (yPercentage < 0) yPercentage = 0;
            if (yPercentage > 100) yPercentage = 100;

            yPercentage = 100 - yPercentage; // reverse direction (icon starts at bottom when scrolling down)

            let xOffset = (availableSpace / 100) * yPercentage;

            // animate icon along X axis in available space
            $icon.css({
                'transform': 'translate3d(' + xOffset + 'px, 0, 0)'
            });
        }
    }, { passive: true });
});